<template>
  <div class="GenericBigText">
    <div class="bg" :style="bgStyle">
      <div class="container">
        <div class="content" v-html="text" :style="textStyle"></div>
        <div class="btnWrapper" v-if="!!btnText">
          <a class="btn" @click="onBtnClick" :href="btnHref" :style="btnStyle">{{btnText}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GenericBigText',
    data(){
      return {

      }
    },
    components:{
    },
    props: {
      text: {
        type: String,
        default: ""
      },
      btnStyle: {
        type: Object,
        default: ()=>{}
      },
      btnHref: {
        type: String,
        default: ""
      },
      btnText: {
        type: String,
        default: ""
      },
      bgStyle: {
        type: Object,
        default: ()=>{}
      },
      textColor: {
        type: String,
        default: "#000"
      }
    },
    methods: {
      onBtnClick: function(e){
        e.preventDefault();
        if(e.currentTarget.href.indexOf('#') > -1){
          var event = new CustomEvent('hashClicked', {
            detail: {
              a: e.target
            }
          });
          window.dispatchEvent(event);
        }else{
          window.location.href = e.currentTarget.href;
        }
      }
    },
    computed: {
      //bgStyle(){
      //  return {
      //    backgroundColor: !!this.bgColor ? this.bgColor : 'transparent',
      //    padding: !!this.bgColor ? '150px 0' : '80px 0',
      //  }
      //},
      textStyle(){
        return {
          color: this.textColor
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';
  .GenericBigText{

    .content{
      font-size: 36px;
      line-height: 52px;
      font-weight: 300;
      @media (max-width: @bootstrap-md - 1px){
        font-size: 22px;
        line-height: 30px;
      }
    }

    .container{
      @media (max-width: @bootstrap-md - 1px){
        padding-left: 30px;
        padding-right: 30px;
      }
    }

    .content /deep/ strong{
      font-weight: bold;
    }

    .bg{
      padding: 60px 0 80px;
      @media (max-width: @bootstrap-md - 1px){
        padding-top: 30px ;
        padding-bottom: 50px ;
      }
    }
    .btn{
      display: inline-block;
      text-decoration: none;
      margin: 50px 0 0;
      @media (max-width: @bootstrap-md - 1px){
        margin-top: 35px;
      }
    }
  }
</style>
